<template>
  <v-container id="report" fluid tag="section">

    <FilterForm
      :filter-form="filterForm"
     />

    <SaleLeaderTable
      :leader="leader"
      :report="report"
    />

  </v-container>
</template>
<script>

import FilterForm from './components/FilterForm'
import SaleLeaderTable from './components/SaleLeaderTable'
import RepositoryFactory from "@/repositories/RepositoryFactory";
const UserRepository = RepositoryFactory.get('user');
const ReportRepository = RepositoryFactory.get('report');
import { formatDate } from '../../../helpers/utils'
import * as moment from 'moment'

export default {
  components: { FilterForm, SaleLeaderTable },
  data() {
    return {
      filterForm: {
        dateRange: {
          startDate: moment().startOf('day').format('YYYY-MM-DD 00:00:00'),
          endDate: moment().endOf('day').format('YYYY-MM-DD 23:59:59'),
        },
      },
      leader: {},
      report: {}
    };
  },
  created() {
    Bus.$on("sale-leader-filter-thpt", filterForm => {
      this.filterForm = filterForm;
      this.getInfoLeader()
      this.getReportLeader()
    });
  },
  beforeDestroy () {
    Bus.$off('sale-leader-filter-thpt')
  },
  methods: {
    async getInfoLeader() {
      const params = {
        id: this.filterForm.userId,
      }
      const loader = this.$loading.show()
      const response = await UserRepository.detail(this.filterForm.userId)
      loader.hide()
      if (response.success) {
       this.leader = _.get(response, 'data', {})
      }
    },
    async getReportLeader() {
      const loader = this.$loading.show()
      const params = {
        userId: this.filterForm.userId,
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
        duration: this.filterForm.dateRange.duration,
        schoolLevelIds: [2]
      };
      console.log(this.filterForm)
      const response = await ReportRepository.saleLeader(params)

      loader.hide()
      if (response.success) {
        this.report = _.get(response, 'data', {})
      }
    }

  }
};
</script>
